
import UserContextProvider from "./services/contexts/UserContextProvider";
import NetworkErrorHandler from "./utils/NetworkErrorHandler";
import React, { useContext } from "react";
import { UserContext } from "./services/contexts/UserContext";
import GetRoutesComponent from "./GetRouteComponent";
import LoginUI from "./pages/Auth/LoginUI";

const App = () => {
  const { isLoggedIn } = useContext(UserContext);

  return (
    <>
      {!isLoggedIn ? <LoginUI /> :(<NetworkErrorHandler><GetRoutesComponent /></NetworkErrorHandler>) }
    </>
  );
};

export default App;
// //*********************************************************** */
// import UserContextProvider from "./services/contexts/UserContextProvider";
// import NetworkErrorHandler from "./utils/NetworkErrorHandler";
// import React, { useContext, useEffect, useState } from "react";
// import { UserContext } from "./services/contexts/UserContext";
// import GetRoutesComponent from "./GetRouteComponent";
// import LoginUI from "./pages/Auth/LoginUI";
// import { jwtDecode } from "jwt-decode";

// const App = () => {
//   const { isLoggedIn, logout } = useContext(UserContext);
//   const [isTokenValid, setIsTokenValid] = useState(false);

//   // Check token validity on app start and regularly
//   useEffect(() => {
//     const checkTokenValidity = () => {
//       const token = sessionStorage.getItem('token');
//       let valid = false;
      
//       if (token) {
//         try {
//           const decoded = jwtDecode(token);
//           const currentTime = Date.now() / 1000;
//           valid = decoded.exp > currentTime;
//           console.log("🔍 App.js: Token validation - valid:", valid, "expiry:", decoded.exp, "current:", currentTime);
//         } catch (error) {
//           console.error("❌ App.js: Error decoding token:", error);
//           valid = false;
//         }
//       }
      
//       setIsTokenValid(valid);
      
//       if (!valid && isLoggedIn) {
//         console.log("🔍 App.js: Token expired or invalid, logging out...");
//         logout();
//       }
//     };

//     // Check immediately on component mount
//     checkTokenValidity();

//     // Set up interval for regular checks (every 30 seconds)
//     const tokenCheckInterval = setInterval(checkTokenValidity, 30000);

//     // Check when user returns to the tab after being away
//     const handleVisibilityChange = () => {
//       if (document.visibilityState === 'visible') {
//         checkTokenValidity();
//       }
//     };

//     document.addEventListener('visibilitychange', handleVisibilityChange);

//     // Check when window gains focus
//     const handleFocus = () => {
//       checkTokenValidity();
//     };

//     window.addEventListener('focus', handleFocus);

//     // Cleanup
//     return () => {
//       clearInterval(tokenCheckInterval);
//       document.removeEventListener('visibilitychange', handleVisibilityChange);
//       window.removeEventListener('focus', handleFocus);
//     };
//   }, [isLoggedIn, logout]);

//   // Determine what to render based on login status and token validity
//   const renderContent = () => {
//     console.log("🔍 App.js: Rendering - isLoggedIn:", isLoggedIn, "isTokenValid:", isTokenValid);
    
//     if (!isLoggedIn || !isTokenValid) {
//       console.log("🔍 App.js: Showing LoginUI");
//       return <LoginUI />;
//     }
    
//     console.log("🔍 App.js: Showing GetRoutesComponent");
//     return (
//       <NetworkErrorHandler>
//         <GetRoutesComponent />
//       </NetworkErrorHandler>
//     );
//   };

//   return <>{renderContent()}</>;
// };

// export default App;
// //********************************************************** */